import {Localstorage} from "@/apiServices/Localstorage";

export class HelperToService extends Localstorage {
    constructor() {
        super();
        this.formatters = {
            number: {
                moneda: (value) => {
                    if (value === undefined || value === null) {
                        return "$0";
                    } else {
                        return new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                        }).format(value);
                    }
                }
            },
            boolean: {
                activoNoActivo: (v) => v === true ? 'activo' : 'No activo',
                aFavorEnContra: (v) => v === true ? 'A favor' : 'En contra',
            },
            string: {
                validarObjetoVacio(objeto) {
                    if (!objeto) return "No asignado"
                    if (objeto === '') return "No asignado"
                    return objeto
                }
            },
            date: {
                dataTimeToLocalString: (value) => {
                    if (value) return new Date(value).toLocaleDateString() + " - " + new Date(value).toLocaleTimeString()
                    else return "Fecha no asignada"
                },
                diasDiferencia: (d1, d2) => {
                    var fechaInicio = new Date(d1).getTime();
                    var fechaFin = new Date(d2).getTime();
                    var diff = fechaFin - fechaInicio;
                    return Math.floor(diff / (1000 * 60 * 60 * 24))
                }
            },
        }
    }

}